exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-7fd989f0]{width:100%;margin:0;text-align:left}ul.notebooks li[data-v-7fd989f0]{list-style:none;width:100%;height:50px;padding:0 20px;background-color:#ddd;border-top:1px solid #fff;border-bottom:1px solid #999;line-height:50px;cursor:pointer}ul.notebooks li[data-v-7fd989f0]:hover{background-color:#eee}.notebook-date[data-v-7fd989f0]{float:right}.notebooks-message[data-v-7fd989f0]{margin:20px}", ""]);

// exports
